import Vue from 'vue'

function formatNumber(num) {
    if (num !== undefined) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
}

Vue.filter('formatNumber', function (num) {
    return formatNumber(num);
});


